var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.92 58.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b94414ca-c733-45a5-b37d-7e721f323697",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.85,132.09a9.78,9.78,0,0,1,1.07-1.47,12.12,12.12,0,0,1,1.67-1.6,11.19,11.19,0,0,1,2-1.29,4.56,4.56,0,0,1,2.06-.52h9.46l-2.25,4.08h-5.79l-2.46,4.45h5.79l-4.32,7.79A9.14,9.14,0,0,1,152,145a13.22,13.22,0,0,1-1.65,1.6,10.45,10.45,0,0,1-2,1.28,4.62,4.62,0,0,1-2,.53H121.47a2.67,2.67,0,0,0-.75.11l-24.4,7.75,21.54-10a20.94,20.94,0,0,1,8.84-1.95h18.2l2.46-4.45h-5.79Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49,132.05h7.84l-6.77,12.29h4.22l-2.25,4.08H152.45Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,148.42l3-5.45h-2.64l-3,5.45h-5.12l9-16.37h11.55a1.86,1.86,0,0,1,1.46.52,2.25,2.25,0,0,1,.57,1.28,4.42,4.42,0,0,1-.12,1.6,5.71,5.71,0,0,1-.55,1.48l-6.34,11.49Zm2.66-9.61h2.64l1.5-2.68h-2.63Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,148.42l6.8-12.29H204l-6.8,12.29H192l6.8-12.29h-2.61l-6.8,12.29H184.3l9-16.37h19.28a1.89,1.89,0,0,1,1.46.52,2.25,2.25,0,0,1,.57,1.28,4.91,4.91,0,0,1-.12,1.6,6.09,6.09,0,0,1-.55,1.48l-6.34,11.49Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,148.42l3-5.45h-2.63l-3,5.45h-5.13l9-16.37H230.3a1.89,1.89,0,0,1,1.46.52,2.17,2.17,0,0,1,.56,1.28,4.64,4.64,0,0,1-.11,1.6,6.09,6.09,0,0,1-.55,1.48l-6.34,11.49Zm2.67-9.61h2.63l1.51-2.68h-2.64Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,165l6.64-10.42h6.55a1.19,1.19,0,0,1,.84.26,1.05,1.05,0,0,1,.31.63,1.83,1.83,0,0,1-.08.79,2.79,2.79,0,0,1-.31.72l-1.23,1.95a3.44,3.44,0,0,1-.42.53,6.1,6.1,0,0,1-.63.6,7.46,7.46,0,0,1-.76.56,4.9,4.9,0,0,1-.85.44L164.2,165h-3.41l.65-3.1-2,3.1Zm9.81-8.41-1.72,2.69h1.57l1.73-2.69Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.25,158.58a8.28,8.28,0,0,1,.94-.78,6.1,6.1,0,0,1,1.11-.63,3,3,0,0,1,1.17-.26h5l-1.26,2h-2.87l-.64,1h2.65l-1.29,2h-2.66l-.64,1h2.87l-1.28,2h-5a1.19,1.19,0,0,1-.84-.26,1.05,1.05,0,0,1-.31-.63,1.92,1.92,0,0,1,.07-.78,2.55,2.55,0,0,1,.31-.73l2.07-3.24A4.62,4.62,0,0,1,169.25,158.58Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,165H178l3.86-6h-1.5l-3.85,6h-2.91l5.12-8h6.55a1.18,1.18,0,0,1,.83.26,1.06,1.06,0,0,1,.32.63,1.92,1.92,0,0,1-.07.78,2.87,2.87,0,0,1-.31.73Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.49,158.91l-3.86,6h-4.45l3.86-6h-1.71l1.27-2h7.86l-1.27,2Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.62,165l1.71-2.68h-1.49L200.13,165h-2.9l5.12-8h6.54a1.18,1.18,0,0,1,.83.26,1,1,0,0,1,.32.63,2.09,2.09,0,0,1-.06.78,2.87,2.87,0,0,1-.32.73L206.07,165Zm1.51-4.72h1.5l.85-1.32H204Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.67,156.21a6.76,6.76,0,0,1,.94-.79,6.26,6.26,0,0,1,1.13-.63,2.91,2.91,0,0,1,1.16-.26h5l-1.28,2h-2.87L217.69,163h2.87l-1.28,2h-5a1.19,1.19,0,0,1-.84-.26,1.05,1.05,0,0,1-.31-.63,2.09,2.09,0,0,1,.06-.78,2.87,2.87,0,0,1,.32-.73l3.57-5.62A4.77,4.77,0,0,1,217.67,156.21Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.86,165l1.7-2.68h-1.49L223.36,165h-2.9l5.12-8h6.54a1.16,1.16,0,0,1,.83.26,1,1,0,0,1,.32.63,1.91,1.91,0,0,1-.06.78,2.87,2.87,0,0,1-.31.73L229.3,165Zm1.51-4.72h1.49l.85-1.32h-1.49Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,165l5.12-8h6.55a1.18,1.18,0,0,1,.83.26,1,1,0,0,1,.32.63,1.92,1.92,0,0,1-.07.78,2.55,2.55,0,0,1-.31.73l-.38.59a2.74,2.74,0,0,1-.44.57,7,7,0,0,1-.68.63,7.46,7.46,0,0,1-.84.6,4.82,4.82,0,0,1-.89.43l0,2.82h-3.5l0-2-1.25,2Zm8.31-6-.86,1.34h1.58l.85-1.34Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "aef4f8ad-a374-4d65-971e-7d6d5cc6c0e3",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.05,147.46S36.6,131.38,76.81,126.14C76.81,126.14,47.84,131.38,52.05,147.46Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.39,157.33s-4.68-1.7-4-5.78C46.39,151.55,48.6,156.14,50.39,157.33Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86,149.93s-15.45-7.4,2.34-15.66c0,0-10.6,5.92-4.09,12.21,1.36.6,1-4,1-4S61.84,144.27,60.86,149.93Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.32,149.93s.6-17.06,27.37-20.09c0,0-21.45,5.07-23.54,20.26Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,149.67s5.07-10.93,17.11-11.14c0,0-7.7,3.4-9.74,7,0,0,23.7-3.49,29.27-9.71C120.94,135.84,114.52,147.67,84.3,149.67Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.35,126.23s9.06,3.61,26.89,4.55C119.24,130.78,94.64,126.14,92.35,126.23Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,125.5S99.32,113.84,121.71,115c10.47.51,14.3,1.78,14.3,1.78s4.44,3.19,6.39,3.45a9.89,9.89,0,0,1-6.48-1.72c-3.45-2.24-4.21,1.68-4.21,1.68s-.7,5.24,2,8L127.05,132s1.08-9.22.76-11.52-2.8-2.14-2.8-2.14h-18.1A43.45,43.45,0,0,0,86.47,125.5Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,129.94h5.59s2.46-1.5,0-2.87-3.83-.45-3.83-.45l-1.4,1.12a1.36,1.36,0,0,1-1-.45.76.76,0,0,0-1-.16s-.93.61.13,1.41A6,6,0,0,1,136.81,129.94Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,151.1l32.81,6.45a3.46,3.46,0,0,1,3.06,3.19c.38,3,.45,4.59.45,4.59h-8a5.12,5.12,0,0,1-2.17-1.56,4.63,4.63,0,0,0-2.46-1.47l-12-3a21.84,21.84,0,0,0-5.59.1c-2,.47-4.94-1.22-4.94-1.22l-1.15-.7Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.15,166.19s16.94,1.7,22.47-2.56C117.62,163.63,113.37,170.53,95.15,166.19Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.24,155.55s-2.38,5,6.08,7.57l36.13,8.34s13.24,2.6,19.15,1.15,137.25-4.21,137.25-4.21L122,167.89a8.12,8.12,0,0,0-2,.25c-3.07.8-12.75,3.12-19.12,2.56-7.66-.69-22.81-3.92-22.81-3.92l-28.43-6.47S45.37,158.78,45.24,155.55Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,150.57s-7.48-3.41-2.12-8A8.62,8.62,0,0,0,49.49,150.57Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,163.1l15.39-1.57a2.71,2.71,0,0,0,2.37-2c.57-2.11,1.63-5.31,2.88-5.42,1.87-.17,83.21-3,83.21-3h-81.1a2.61,2.61,0,0,0-.79.12l-22.68,6.87a2.61,2.61,0,0,0-.92.48c-.82.67-2.19,2.17-.47,3.84A2.62,2.62,0,0,0,96,163.1Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42,122s-5,.17-8.21-1.27a16.85,16.85,0,0,1-3.67-1.91s-1.07-.76-1.58.63c0,0,.69-.73,1.34-.23s3.42,3.62,12.12,4.78Z",
    transform: "translate(-44.93 -114.95)",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.48 7.01 169.18 8.01 101.48 9.01 101.48 7.01",
    style: {
      fill: "#ed1c24"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.3d82e1792ed086df2357976636e7840c.svg";
export { ForwardRef as ReactComponent };